const PREFIX = "contentchat:chat:v1";
export const CHAT_HISTORY_UPDATED = "contentchat:chat-history-updated";

export function currentChatUserId() {
  try {
    if (!localStorage.getItem("token")) return null;
    const user = JSON.parse(localStorage.getItem("currentUser") || "null");
    return typeof user?.id === "string" && user.id ? user.id : null;
  } catch {
    return null;
  }
}

export function chatHistoryKey(userId, businessId) {
  const owner = userId ? `user:${encodeURIComponent(userId)}` : "visitor";
  return `${PREFIX}:${owner}:business:${encodeURIComponent(businessId)}`;
}

export function newChatHistory() {
  return {
    version: 1,
    sessionId: globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    revision: 0,
    messages: [],
  };
}

export function readChatHistory(key) {
  try {
    const data = JSON.parse(localStorage.getItem(key) || "null");
    if (
      data?.version !== 1 || typeof data.sessionId !== "string" || !data.sessionId ||
      !Number.isSafeInteger(data.revision) || data.revision < 0 ||
      !Array.isArray(data.messages) || !data.messages.every((message) =>
        message && ["user", "assistant"].includes(message.role) && typeof message.content === "string")
    ) return null;
    return data;
  } catch {
    return null;
  }
}

export function writeChatHistory(key, history) {
  try {
    localStorage.setItem(key, JSON.stringify(history));
  } catch {
    // Restricted/full browser storage must not interrupt the existing chat flow.
    return false;
  }
  // The browser's storage event only notifies other tabs, not this page.
  window.dispatchEvent(new CustomEvent(CHAT_HISTORY_UPDATED, { detail: { key } }));
  return true;
}
